import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack } from "@mui/material";
import { Button } from "reactstrap";
import "./common.css"
//Import Breadcrumb

const AppDialog = ({
    open, width, title, close, children, fullWidth = false,
    closable, disabled, negativePress, negativeTitle, positivePress,
    positiveTitle, positiveButtonStyle, negativeButtonStyle, actionButtonStyle,
    titleIcon,
}) => {
    return (
        <React.Fragment>
            <Dialog
                open={open}
                fullWidth={fullWidth}
                PaperProps={{
                    sx: {
                        // height: height || '700px',
                        width: { xs: "100%", sm: width || '70%' },
                        borderRadius: "10px",
                        maxWidth: { xs: "100%", sm: width || '70%' },
                    }
                }}
                onClose={(e) => close()}
            >
                <DialogTitle>
                    {
                        titleIcon === 'warning' &&
                        <div className="modal-icon-title-warning">
                            <div className="modal-icon-title-inner-container-warning">
                                <i className="ri-alert-line" style={{ fontSize: 26 }} />
                            </div>
                        </div>
                    }
                    {
                        (titleIcon === 'edit' || titleIcon === 'add') &&
                        <div className="modal-icon-title-theme">
                            <div className="modal-icon-title-inner-container-theme">
                                <i className={`ri-${titleIcon === 'add' ? 'add' : 'pencil'}-line`} style={{ fontSize: 26 }} />
                            </div>
                        </div>
                    }
                    {
                        titleIcon === 'complete' &&
                        <div className="modal-icon-title-complete">
                            <div className="modal-icon-title-inner-container-complete">
                                <i className={`ri-checkbox-circle-line`} style={{ fontSize: 26 }} />
                            </div>
                        </div>
                    }
                    {
                        titleIcon === 'error' &&
                        <div className="modal-icon-title-theme">
                            <div className="modal-icon-title-inner-container-theme">
                                <i className={`ri-error-warning-line`} style={{ fontSize: 26 }} />
                            </div>
                        </div>
                    }
                    {
                        titleIcon === 'reject' &&
                        <div className="modal-icon-title-theme">
                            <div className="modal-icon-title-inner-container-theme">
                                <i className={`ri-close-line`} style={{ fontSize: 26 }} />
                            </div>
                        </div>
                    }{
                        titleIcon === 'view' &&
                        <div className="modal-icon-title-view">
                            <div className="modal-icon-title-inner-container-view">
                                <i className={`ri-eye-line`} style={{ fontSize: 26 }} />
                            </div>
                        </div>
                    }
                    {
                        !titleIcon && title
                    }

                    {
                        title && titleIcon &&
                        <div className="modal-title pt-3">{title}</div>
                    }
                </DialogTitle>
                {
                    closable != false &&
                    <IconButton
                        aria-label="close"
                        onClick={(e) => close()}
                        sx={{
                            position: 'absolute',
                            right: titleIcon ? 20 : 8,
                            top: titleIcon ? 23 : 8,
                            paddingInline: '10px',
                            height: '40px',
                            width: '40px',
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <i className="ri-close-large-line"></i>
                    </IconButton>
                }

                <DialogContent dividers={titleIcon ? false : true} className="pt-0">
                    {children}
                    <Stack sx={{ position: "absolute", bottom: "30px", right: "20px", flexDirection: { xs: "column-reverse", sm: "row" }, justifyContent: { xs: "center", sm: "flex-end" } }} justifyContent={"flex-end"} gap={2} pt={2}>

                    </Stack>
                </DialogContent>
                <DialogActions className={actionButtonStyle || ''} style={{ padding: '15px' }}>
                    {
                        negativeTitle &&
                        <Button onClick={(e) => negativePress ? negativePress() : ""} style={negativeButtonStyle ? negativeButtonStyle : {}} className=" me-1 modal-negative-button" type="submit">
                            {negativeTitle}
                        </Button>
                    }
                    <Button color="primary" className="w-md modal-positive-button" style={positiveButtonStyle ? positiveButtonStyle : {}} type="submit" disabled={disabled || false} onClick={(e) => positivePress()}>
                        {positiveTitle}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

export default AppDialog;
